import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';

function AdvancedSearch() {
    const [title, setTitle] = useState('');
    const [author, setAuthor] = useState('');
    const [genre, setGenre] = useState('');
    const [fromYear, setFromYear] = useState('');
    const [toYear, setToYear] = useState('');
    const [type, setType] = useState('all');
    const [entireText, setEntireText] = useState('');
    const [excludeText, setExcludeText] = useState('');
    const [proximity, setProximity] = useState('');
    const [section, setSection] = useState('any');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setTitle(params.get('title') || '');
        setAuthor(params.get('author') || '');
        setGenre(params.get('genre') || '');
        setFromYear(params.get('fromYear') || '');
        setToYear(params.get('toYear') || '');
        setType(params.get('type') || 'all');
        setEntireText(params.get('entireText') || '');
        setExcludeText(params.get('excludeText') || '');
        setProximity(params.get('proximity') || '');
        setSection(params.get('section') || 'any');
    }, [location.search]);

    const handleSubmit = (event) => {
        event.preventDefault();

        if (fromYear && !toYear) {
            setError('Please enter a "to" year.');
            return;
        }
        if (!fromYear && toYear) {
            setError('Please enter a "from" year.');
            return;
        }

        if (!title && !author && !genre && !entireText && !fromYear && !toYear) {
            setError('Please fill out at least one field: Title, Author, Genre, Entire Text, or Year(s).');
            return;
        }

        setError('');

        const params = new URLSearchParams({
            title,
            author,
            genre,
            fromYear,
            toYear,
            type,
            entireText,
            excludeText,
            proximity,
            section,
            smode: 'advanced',
        });

        navigate(`/searchresults?${params.toString()}`);
    };

    return (
        <div className="advanced-search-page">
            <div className="tabs">
                <NavLink className={({ isActive }) => isActive ? "tab-link active-tab" : "tab-link"} to="/search">
                    Keyword
                </NavLink>
                <NavLink className={({ isActive }) => isActive ? "tab-link active-tab" : "tab-link"} to="/advanced-search">
                    Advanced
                </NavLink>
                <NavLink className={({ isActive }) => isActive ? "tab-link active-tab" : "tab-link"} to="/freeform-search">
                    Freeform
                </NavLink>
                <NavLink className={({ isActive }) => isActive ? "tab-link active-tab" : "tab-link"} to="/browse">
                    Browse
                </NavLink>
            </div>
            <h2>Advanced Search</h2>
            <form className="advanced-search-form" onSubmit={handleSubmit}>
                <div className="advanced-search-container">
                    <div className="left-section">
                        <label htmlFor="EntireText">Entire Text:</label>
                        <input type="text" id="EntireText" value={entireText} onChange={(e) => setEntireText(e.target.value)} />

                        <label htmlFor="ExcludeText">Exclude:</label>
                        <input type="text" id="ExcludeText" value={excludeText} onChange={(e) => setExcludeText(e.target.value)} />

                        <div className="proximity-container">
                            <label htmlFor="Proximity">Proximity:</label>
                            <select id="Proximity" value={proximity} onChange={(e) => setProximity(e.target.value)}>
                                <option value=""></option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="20">20</option>
                            </select>
                            <span>word(s)</span>
                        </div>
                        {/* 
                        <label>Section:</label>
                        <div>
                            <label><input type="radio" name="section" value="any" checked={section === 'any'} onChange={() => setSection('any')} /> Any</label>
                            <label><input type="radio" name="section" value="headings" checked={section === 'headings'} onChange={() => setSection('headings')} /> Headings</label>
                            <label><input type="radio" name="section" value="citations" checked={section === 'citations'} onChange={() => setSection('citations')} /> Citations</label>
                        </div>
                        */}
                    </div>

                    <div className="right-section">
                        <label htmlFor="Title">Title:</label>
                        <input type="text" id="Title" value={title} onChange={(e) => setTitle(e.target.value)} />

                        <label htmlFor="Author">Author:</label>
                        <input type="text" id="Author" value={author} onChange={(e) => setAuthor(e.target.value)} />

                        <label htmlFor="Genre">Genre:</label>
                        <input type="text" id="Genre" value={genre} onChange={(e) => setGenre(e.target.value)} />

                        <label>Year(s):</label>
                        <div className="year-range">
                            <input type="text" placeholder="From" value={fromYear} onChange={(e) => setFromYear(e.target.value)} />
                            <input type="text" placeholder="To" value={toYear} onChange={(e) => setToYear(e.target.value)} />
                        </div>
                        {/* 
                        <div className="type-container">
                            <label htmlFor="Type">Type:</label>
                            <select id="Type" value={type} onChange={(e) => setType(e.target.value)}>
                                <option value="all">All</option>
                                <option value="ead">EAD</option>
                                <option value="html">HTML</option>
                                <option value="word">Word</option>
                                <option value="nlm">NLM</option>
                                <option value="pdf">PDF</option>
                                <option value="tei">TEI</option>
                                <option value="text">Text</option>
                            </select>
                        </div>
                        */}
                        <div className="button-group">
                            <button type="submit">Search</button>
                            <button type="button" onClick={() => {
                                setTitle('');
                                setAuthor('');
                                setGenre('');
                                setFromYear('');
                                setToYear('');
                                setType('all');
                                setEntireText('');
                                setExcludeText('');
                                setSection('');
                                setError('');
                            }}>Clear</button>
                        </div>
                    </div>
                </div>

            </form>

            {error && <p className="error-message">{error}</p>}
            <div className="search-examples">
                <h3>Examples:</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Criteria</th>
                            <th>Explanation</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>south america</td>
                            <td>Search full text for 'south' AND 'america'</td>
                        </tr>
                        <tr>
                            <td>Exclude: race</td>
                            <td>Exclude results which contain the term 'race'</td>
                        </tr>
                        <tr>
                            <td>Proximity: 5</td>
                            <td>Match the full text terms, only if they are 5 or fewer words apart</td>
                        </tr>
                        <tr>
                            <td>Section: headings</td>
                            <td>Match the full text terms, only if they appear in document 'headings' (e.g., chapter titles)</td>
                        </tr>
                        <tr>
                            <td>Title: "south america"</td>
                            <td>Search for the phrase 'south america' in the 'title' field</td>
                        </tr>
                        <tr>
                            <td>Year(s): from 1788 to 1822</td>
                            <td>Search for documents whose date falls in the range from '1788' to '1822'</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    );

}

export default AdvancedSearch;
